import React from "react";
import { Grid, Heading, VerticalSpacing, VerticalSpacingSizes } from "../../../..";
import { Section } from "../../../../elements/Section";
import { types } from "../../../../elements/Heading";
import { Rank } from "../../../../core";

/* eslint-disable camelcase */

/* eslint-disable @typescript-eslint/camelcase */
var ProductDetailNotification = function ProductDetailNotification(_ref) {
  var notification = _ref.notification;
  return /*#__PURE__*/React.createElement(Section, {
    fullWidth: true,
    background: "grayDark"
  }, /*#__PURE__*/React.createElement(Grid, {
    variant: "3/4,1/4",
    gutterlessAtNarrow: true
  }, /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(VerticalSpacing, {
    size: VerticalSpacingSizes.XS
  }, /*#__PURE__*/React.createElement(Heading, {
    type: types.ExtraLarge,
    rank: Rank.First
  }, /*#__PURE__*/React.createElement("strong", null, notification))))));
};

ProductDetailNotification.displayName = "ProductDetailNotification";
export default ProductDetailNotification;